export interface PricePerTax {
  price: number | null;
  tax_amount: number | null;
  tax_rate: TaxRate;
  price_type: 'total' | 'usage_point';
}

export type TaxRate = Util.ValueOf<typeof TAX_RATE>;

export const TAX_RATE = {
  TAX_RATE_8: 8,
  TAX_RATE_10: 10,
} as const;

export type TaxRateKey = keyof typeof TAX_RATE;
